export default {
	state: {
		currentTab: null,
		tabs: [],
		highestIndex: 0
	},
	mutations: {
		tabs_register(state, payload) {
			const { tabs, currentTab } = payload;
			state.tabs = tabs;
			state.currentTab = currentTab || tabs[0];
		},
		tabs_unregister(state) {
			state.currentTab = null;
			state.tabs = [];
			state.highestIndex = 0;
		},
		tabs_next(state) {
			const currentIndex = state.tabs.indexOf(state.currentTab);
			if (currentIndex === -1 || currentIndex === state.tabs.length - 1)
				return;
			state.currentTab = state.tabs[currentIndex + 1];
			state.highestIndex = currentIndex + 1;
		},
		tabs_prev(state) {
			const currentIndex = state.tabs.indexOf(state.currentTab);
			if (currentIndex === -1 || currentIndex === 0) return;
			state.currentTab = state.tabs[currentIndex - 1];
		},
		tabs_select(state, payload) {
			const { tab } = payload;
			state.currentTab = tab;
		}
	},
	getters: {
		tabsCurrent(state) {
			return state.currentTab;
		},
		tabsCurrentIndex(state, getters) {
			return getters.tabsIndexOf(state.currentTab);
		},
		tabsHighestIndex(state) {
			return state.highestIndex;
		},
		tabsIndexOf: (state) => (tab) => {
			return state.tabs.indexOf(tab);
		},
		tabsIsLast(state, getters) {
			return getters.tabsCurrentIndex === state.tabs.length - 1;
		},
		tabsIsFirst(state, getters) {
			return getters.tabsCurrentIndex === 0;
		}
	}
};
